<form [formGroup]="formGroup">
  <div *ngFor="let formElement of formElements" [class]="formElement.parent">
    <ng-container>
      <div
        *ngFor="let inputElement of formElement.inputs"
        [class]="inputElement.column"
        [ngSwitch]="inputElement.elementName"
      >
        <div *ngSwitchCase="'text-input'">
          <text-input
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputUpdated)="getTextboxValue($event)"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
            (inputEnterEvent)="this[inputElement.onEnter]()"
          ></text-input>
        </div>
        <div *ngSwitchCase="'text-label'">
          <text-label
            [label]="inputElement.label"
            [className]="inputElement.className"
            [name]="inputElement.forName"
          ></text-label>
        </div>
        <div *ngSwitchCase="'primary-btn'">
          <primary-btn
            [primaryButtonSetting]="inputElement"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]($event)"
            (inputBlurEvent)="this[inputElement.onBlur]()"
          ></primary-btn>
        </div>
        <div *ngSwitchCase="'checkbox'">
          <checkbox
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputUpdated)="getCheckboxValue($event)"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
          ></checkbox>
        </div>
        <div *ngSwitchCase="'select-list'">
          <select-list
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputUpdated)="getSelectListValue($event)"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
            (inputEnterEvent)="this[inputElement.onEnter]()"
          >
          </select-list>
        </div>

        <div *ngSwitchCase="'numberInput'">
          <number-input
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputUpdated)="getNumberInputValue($event)"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputEnterEvent)="this[inputElement.onEnter]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
          >
          </number-input>
        </div>
        <div *ngSwitchCase="'radio-button'">
          <radio-button
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputUpdated)="getRadioButtonValue($event)"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
            (inputKeyupEvent)="this[inputElement.onKeyUp]()"
          ></radio-button>
        </div>
        <div *ngSwitchCase="'date-picker'">
          <date-picker
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputUpdated)="getDatepickerUpdate($event)"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputEnterEvent)="this[inputElement.onKeyUp]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
          ></date-picker>
        </div>
        <div *ngSwitchCase="'text-area'">
          <text-area
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
            (inputEnterEvent)="this[inputElement.onEnter]()"
            (inputUpdated)="getTextAreaValue($event)"
          ></text-area>
        </div>
        <div *ngSwitchCase="'radio-switch'">
          <radio-switch
            [form]="formGroup"
            [errors]="errorArray"
            [settings]="inputElement"
            (inputUpdated)="getRadioSwitchValue($event)"
            (inputFocusEvent)="this[inputElement.onFocus]()"
            (inputClickEvent)="this[inputElement.onClick]()"
            (inputBlurEvent)="this[inputElement.onBlur]()"
          ></radio-switch>
        </div>
      </div>
    </ng-container>
  </div>
</form>
